import React, { useEffect } from "react";
import { connect }  from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

// core components
import Form from './form';

function CreateDialog(props) {
    const { sector, closeDialog, created, isOpen, isSubSector } = props;

    useEffect(() => {
        if (created) {
            closeDialog();
        }
    }, [created]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'sm'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={isSubSector ? "sector.form.sub.create.title" : "sector.form.create.title"} />
            </DialogTitle>
            <DialogContent>
                <Form
                    closeDialog={closeDialog}
                    sector={isSubSector && sector}
                    isSubSector={isSubSector}
                />
            </DialogContent>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        created: state.sector.create.created,
    }
};

export default connect(
    mapStateToProps,
    null,
)(CreateDialog);
